(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.taylor = factory());
}(this, (function () { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn) {
	  var module = { exports: {} };
		return fn(module, module.exports), module.exports;
	}

	var env = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Env = void 0;

	class Env {
	    constructor(outer, binds = [], exprts = []) {
	        this.outer = outer;
	        this.data = new Map();
	        for (let i = 0; i < binds.length; i++) {
	            const bind = binds[i];
	            if (bind.v === "&") {
	                this.set(binds[i + 1], new types.MalList(exprts.slice(i)));
	                break;
	            }
	            this.set(bind, exprts[i]);
	        }
	    }
	    set(key, value) {
	        this.data.set(key, value);
	        if (this.debug) {
	            this.operations.push({ key, value, type: 'set' });
	        }
	        return value;
	    }
	    find(key) {
	        if (this.data.has(key)) {
	            return this;
	        }
	        if (this.outer) {
	            return this.outer.find(key);
	        }
	        return void 0;
	    }
	    get(key) {
	        const env = this.find(key);
	        if (!env) {
	            throw new Error(`'${key.v}' not found`);
	        }
	        const v = env.data.get(key);
	        if (!v) {
	            throw new Error(`'${key.v}' not found`);
	        }
	        if (this.debug) {
	            this.operations.push({ key, value: v, type: 'get' });
	        }
	        return v;
	    }
	    flushDebug() {
	        this.operations = [];
	    }
	}
	exports.Env = Env;
	});

	var types = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MalAtom = exports.MalFunction = exports.MalHashMap = exports.MalVector = exports.MalKeyword = exports.MalSymbol = exports.MalBoolean = exports.MalNil = exports.MalString = exports.MalNumber = exports.MalList = exports.isAST = exports.isSeq = exports.equals = void 0;

	function equals(a, b, strict) {
	    if (strict && a.type !== b.type) {
	        return false;
	    }
	    if (a.type === 4 /* Nil */ && b.type === 4 /* Nil */) {
	        return true;
	    }
	    if (isSeq(a) && isSeq(b)) {
	        return listEquals(a.list, b.list);
	    }
	    if (a.type === 9 /* HashMap */ && b.type === 9 /* HashMap */) {
	        if (a.keywordMap.size !== b.keywordMap.size) {
	            return false;
	        }
	        if (Object.keys(a.stringMap).length !== Object.keys(b.stringMap).length) {
	            return false;
	        }
	        for (const [aK, aV] of a.entries()) {
	            if (aK.type !== 3 /* String */ && aK.type !== 7 /* Keyword */) {
	                throw new Error(`unexpected symbol: ${aK.type}, expected: string or keyword`);
	            }
	            const bV = b.get(aK);
	            if (aV.type === 4 /* Nil */ && bV.type === 4 /* Nil */) {
	                continue;
	            }
	            if (!equals(aV, bV)) {
	                return false;
	            }
	        }
	        return true;
	    }
	    if ((a.type === 2 /* Number */ && b.type === 2 /* Number */)
	        || (a.type === 3 /* String */ && b.type === 3 /* String */)
	        || (a.type === 5 /* Boolean */ && b.type === 5 /* Boolean */)
	        || (a.type === 6 /* Symbol */ && b.type === 6 /* Symbol */)
	        || (a.type === 7 /* Keyword */ && b.type === 7 /* Keyword */)) {
	        return a.v === b.v;
	    }
	    return false;
	    function listEquals(a, b) {
	        if (a.length !== b.length) {
	            return false;
	        }
	        for (let i = 0; i < a.length; i++) {
	            if (!equals(a[i], b[i], strict)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	exports.equals = equals;
	function isSeq(ast) {
	    return ast.type === 1 /* List */ || ast.type === 8 /* Vector */;
	}
	exports.isSeq = isSeq;
	function isAST(v) {
	    return !!v.type;
	}
	exports.isAST = isAST;
	class MalList {
	    constructor(list) {
	        this.list = list;
	        this.type = 1 /* List */;
	    }
	    withMeta(meta) {
	        const v = new MalList(this.list);
	        v.meta = meta;
	        return v;
	    }
	}
	exports.MalList = MalList;
	class MalNumber {
	    constructor(v) {
	        this.v = v;
	        this.type = 2 /* Number */;
	    }
	    withMeta(meta) {
	        const v = new MalNumber(this.v);
	        v.meta = meta;
	        return v;
	    }
	}
	exports.MalNumber = MalNumber;
	class MalString {
	    constructor(v) {
	        this.v = v;
	        this.type = 3 /* String */;
	    }
	    withMeta(meta) {
	        const v = new MalString(this.v);
	        v.meta = meta;
	        return v;
	    }
	}
	exports.MalString = MalString;
	class MalNil {
	    constructor() {
	        this.type = 4 /* Nil */;
	    }
	    static get instance() {
	        if (this._instance) {
	            return this._instance;
	        }
	        this._instance = new MalNil();
	        return this._instance;
	    }
	    withMeta(_meta) {
	        throw new Error(`not supported`);
	    }
	}
	exports.MalNil = MalNil;
	class MalBoolean {
	    constructor(v) {
	        this.v = v;
	        this.type = 5 /* Boolean */;
	    }
	    withMeta(meta) {
	        const v = new MalBoolean(this.v);
	        v.meta = meta;
	        return v;
	    }
	}
	exports.MalBoolean = MalBoolean;
	class MalSymbol {
	    constructor(v) {
	        this.v = v;
	        this.type = 6 /* Symbol */;
	    }
	    static get(name) {
	        const sym = Symbol.for(name);
	        let token = this.map.get(sym);
	        if (token) {
	            return token;
	        }
	        token = new MalSymbol(name);
	        this.map.set(sym, token);
	        return token;
	    }
	    withMeta(_meta) {
	        throw new Error(`not supported`);
	    }
	}
	exports.MalSymbol = MalSymbol;
	MalSymbol.map = new Map();
	class MalKeyword {
	    constructor(v) {
	        this.v = v;
	        this.type = 7 /* Keyword */;
	    }
	    static get(name) {
	        const sym = Symbol.for(name);
	        let token = this.map.get(sym);
	        if (token) {
	            return token;
	        }
	        token = new MalKeyword(name);
	        this.map.set(sym, token);
	        return token;
	    }
	    withMeta(_meta) {
	        throw new Error(`not supported`);
	    }
	}
	exports.MalKeyword = MalKeyword;
	MalKeyword.map = new Map();
	class MalVector {
	    constructor(list) {
	        this.list = list;
	        this.type = 8 /* Vector */;
	    }
	    withMeta(meta) {
	        const v = new MalVector(this.list);
	        v.meta = meta;
	        return v;
	    }
	}
	exports.MalVector = MalVector;
	class MalHashMap {
	    constructor(list) {
	        this.type = 9 /* HashMap */;
	        this.stringMap = {};
	        this.keywordMap = new Map();
	        while (list.length !== 0) {
	            const key = list.shift();
	            const value = list.shift();
	            if (value == null) {
	                throw new Error("unexpected hash length");
	            }
	            if (key.type === 7 /* Keyword */) {
	                this.keywordMap.set(key, value);
	            }
	            else if (key.type === 3 /* String */) {
	                this.stringMap[key.v] = value;
	            }
	            else {
	                throw new Error(`unexpected key symbol: ${key.type}, expected: keyword or string`);
	            }
	        }
	    }
	    withMeta(meta) {
	        const v = this.assoc([]);
	        v.meta = meta;
	        return v;
	    }
	    has(key) {
	        if (key.type === 7 /* Keyword */) {
	            return !!this.keywordMap.get(key);
	        }
	        return !!this.stringMap[key.v];
	    }
	    get(key) {
	        if (key.type === 7 /* Keyword */) {
	            return this.keywordMap.get(key) || MalNil.instance;
	        }
	        return this.stringMap[key.v] || MalNil.instance;
	    }
	    entries() {
	        const list = [];
	        this.keywordMap.forEach((v, k) => {
	            list.push([k, v]);
	        });
	        Object.keys(this.stringMap).forEach(v => list.push([new MalString(v), this.stringMap[v]]));
	        return list;
	    }
	    keys() {
	        const list = [];
	        this.keywordMap.forEach((_v, k) => {
	            list.push(k);
	        });
	        Object.keys(this.stringMap).forEach(v => list.push(new MalString(v)));
	        return list;
	    }
	    vals() {
	        const list = [];
	        this.keywordMap.forEach(v => {
	            list.push(v);
	        });
	        Object.keys(this.stringMap).forEach(v => list.push(this.stringMap[v]));
	        return list;
	    }
	    assoc(args) {
	        const list = [];
	        this.keywordMap.forEach((value, key) => {
	            list.push(key);
	            list.push(value);
	        });
	        Object.keys(this.stringMap).forEach(keyStr => {
	            list.push(new MalString(keyStr));
	            list.push(this.stringMap[keyStr]);
	        });
	        return new MalHashMap(list.concat(args));
	    }
	    dissoc(args) {
	        const newHashMap = this.assoc([]);
	        args.forEach(arg => {
	            if (arg.type === 3 /* String */) {
	                delete newHashMap.stringMap[arg.v];
	            }
	            else if (arg.type === 7 /* Keyword */) {
	                newHashMap.keywordMap.delete(arg);
	            }
	            else {
	                throw new Error(`unexpected symbol: ${arg.type}, expected: keyword or string`);
	            }
	        });
	        return newHashMap;
	    }
	}
	exports.MalHashMap = MalHashMap;
	class MalFunction {
	    constructor() {
	        this.type = 10 /* Function */;
	    }
	    static fromLisp(evalMal, env$1, params, bodyAst) {
	        const f = new MalFunction();
	        f.func = (...args) => evalMal(bodyAst, new env.Env(env$1, params, checkUndefined(args)));
	        f.env = env$1;
	        f.params = params;
	        f.ast = bodyAst;
	        f.isMacro = false;
	        return f;
	        function checkUndefined(args) {
	            return args.map(arg => {
	                if (!arg) {
	                    throw new Error(`undefined argument`);
	                }
	                return arg;
	            });
	        }
	    }
	    static fromBootstrap(func) {
	        const f = new MalFunction();
	        f.func = func;
	        f.isMacro = false;
	        return f;
	    }
	    toMacro() {
	        const f = new MalFunction();
	        f.func = this.func;
	        f.ast = this.ast;
	        f.env = this.env;
	        f.params = this.params;
	        f.isMacro = true;
	        f.meta = this.meta;
	        return f;
	    }
	    withMeta(meta) {
	        const f = new MalFunction();
	        f.func = this.func;
	        f.ast = this.ast;
	        f.env = this.env;
	        f.params = this.params;
	        f.isMacro = this.isMacro;
	        f.meta = meta;
	        return f;
	    }
	    newEnv(args) {
	        return new env.Env(this.env, this.params, args);
	    }
	}
	exports.MalFunction = MalFunction;
	class MalAtom {
	    constructor(v) {
	        this.v = v;
	        this.type = 11 /* Atom */;
	    }
	    withMeta(meta) {
	        const v = new MalAtom(this.v);
	        v.meta = meta;
	        return v;
	    }
	}
	exports.MalAtom = MalAtom;
	});

	var reader = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.readStr = void 0;

	class Reader {
	    constructor(tokens) {
	        this.tokens = tokens;
	        this.position = 0;
	    }
	    next() {
	        const ret = this.peek();
	        this.position += 1;
	        return ret;
	    }
	    peek() {
	        return this.tokens[this.position];
	    }
	}
	function readStr(input) {
	    const tokens = tokenizer(input);
	    const reader = new Reader(tokens);
	    return readForm(reader);
	}
	exports.readStr = readStr;
	function tokenizer(input) {
	    const regexp = /[\s,]*(~@|[\[\]{}()'`~^@]|"(?:\\.|[^\\"])*"?|;.*|[^\s\[\]{}('"`,;)]*)/g;
	    const tokens = [];
	    while (true) {
	        const matches = regexp.exec(input);
	        if (!matches) {
	            break;
	        }
	        const match = matches[1];
	        if (match === "") {
	            break;
	        }
	        if (match[0] !== ";") {
	            tokens.push(match);
	        }
	    }
	    return tokens;
	}
	function readForm(reader) {
	    const token = reader.peek();
	    switch (token) {
	        case "(":
	            return readList(reader);
	        case "[":
	            return readVector(reader);
	        case "{":
	            return readHashMap(reader);
	        case "'":
	            return readSymbol("quote");
	        case "`":
	            return readSymbol("quasiquote");
	        case "~":
	            return readSymbol("unquote");
	        case "~@":
	            return readSymbol("splice-unquote");
	        case "@":
	            return readSymbol("deref");
	        case "^":
	            {
	                reader.next();
	                const sym = types.MalSymbol.get("with-meta");
	                const target = readForm(reader);
	                return new types.MalList([sym, readForm(reader), target]);
	            }
	        default:
	            return readAtom(reader);
	    }
	    function readSymbol(name) {
	        reader.next();
	        const sym = types.MalSymbol.get(name);
	        const target = readForm(reader);
	        return new types.MalList([sym, target]);
	    }
	}
	function readList(reader) {
	    return readParen(reader, types.MalList, "(", ")");
	}
	function readVector(reader) {
	    return readParen(reader, types.MalVector, "[", "]");
	}
	function readHashMap(reader) {
	    return readParen(reader, types.MalHashMap, "{", "}");
	}
	function readParen(reader, ctor, open, close) {
	    const token = reader.next(); // drop open paren
	    if (token !== open) {
	        throw new Error(`unexpected token ${token}, expected ${open}`);
	    }
	    const list = [];
	    while (true) {
	        const next = reader.peek();
	        if (next === close) {
	            break;
	        }
	        else if (!next) {
	            throw new Error("unexpected EOF");
	        }
	        list.push(readForm(reader));
	    }
	    reader.next(); // drop close paren
	    return new ctor(list);
	}
	function readAtom(reader) {
	    const token = reader.next();
	    if (token.match(/^-?[0-9]+$/)) {
	        const v = parseInt(token, 10);
	        return new types.MalNumber(v);
	    }
	    if (token.match(/^-?[0-9]\.[0-9]+$/)) {
	        const v = parseFloat(token);
	        return new types.MalNumber(v);
	    }
	    if (token.match(/^"(?:\\.|[^\\"])*"$/)) {
	        const v = token.slice(1, token.length - 1)
	            .replace(/\\(.)/g, (_, c) => c == 'n' ? '\n' : c);
	        return new types.MalString(v);
	    }
	    if (token[0] === '"') {
	        throw new Error("expected '\"', got EOF");
	    }
	    if (token[0] === ":") {
	        return types.MalKeyword.get(token.substr(1));
	    }
	    switch (token) {
	        case "nil":
	            return types.MalNil.instance;
	        case "true":
	            return new types.MalBoolean(true);
	        case "false":
	            return new types.MalBoolean(false);
	    }
	    return types.MalSymbol.get(token);
	}
	});

	var printer = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.prStr = void 0;
	function prStr(v, printReadably = true) {
	    switch (v.type) {
	        case 1 /* List */:
	            return `(${v.list.map(v => prStr(v, printReadably)).join(" ")})`;
	        case 8 /* Vector */:
	            return `[${v.list.map(v => prStr(v, printReadably)).join(" ")}]`;
	        case 9 /* HashMap */:
	            let result = "{";
	            for (const [key, value] of v.entries()) {
	                if (result !== "{") {
	                    result += " ";
	                }
	                result += `${prStr(key, printReadably)} ${prStr(value, printReadably)}`;
	            }
	            result += "}";
	            return result;
	        case 2 /* Number */:
	        case 6 /* Symbol */:
	        case 5 /* Boolean */:
	            return `${v.v}`;
	        case 3 /* String */:
	            if (printReadably) {
	                const str = v.v
	                    .replace(/\\/g, "\\\\")
	                    .replace(/"/g, '\\"')
	                    .replace(/\n/g, "\\n");
	                return `"${str}"`;
	            }
	            else {
	                return v.v;
	            }
	        case 4 /* Nil */:
	            return "nil";
	        case 7 /* Keyword */:
	            return `:${v.v}`;
	        case 10 /* Function */:
	            return "#<function>";
	        case 11 /* Atom */:
	            return `(atom ${prStr(v.v, printReadably)})`;
	    }
	}
	exports.prStr = prStr;
	});

	var interop = createCommonjsModule(function (module, exports) {
	// Node vs browser behavior
	// if (typeof module === 'undefined') {
	//     var GLOBAL = window;
	// }
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.tay2js = exports.jsToMal = exports.resolveJs = void 0;

	const GLOBAL = {};
	function resolveJs(str) {
	    if (str.match(/\./)) {
	        var re = /^(.*)\.[^\.]*$/, match = re.exec(str);
	        return [match ? eval(match[1]) : null, eval(str)];
	    }
	    else {
	        return [GLOBAL, eval(str)];
	    }
	}
	exports.resolveJs = resolveJs;
	function jsToMal(obj) {
	    if (obj === null || obj === undefined) {
	        return types.MalNil.instance;
	    }
	    var cache = [];
	    let str, value;
	    if (typeof obj === 'object') {
	        str = JSON.stringify(obj, function (_, value) {
	            if (typeof value === 'object' && value !== null) {
	                if (cache.indexOf(value) !== -1) {
	                    // Circular reference found, discard key
	                    return;
	                }
	                // Store value in our collection
	                cache.push(value);
	            }
	            return value;
	        });
	        cache = null; // Enable garbage collection
	        value = JSON.parse(str);
	    }
	    else {
	        value = obj;
	    }
	    if (value === null)
	        return types.MalNil.instance;
	    if (typeof value === 'number')
	        return new types.MalNumber(value);
	    if (typeof value === 'string')
	        return new types.MalString(value);
	    if (typeof value === 'boolean')
	        return new types.MalBoolean(value);
	    if (typeof value === 'function') {
	        // const ff = new MalFunction();
	        // ff.func = value;
	        // return ff;
	        return value;
	    }
	    if (value instanceof Array) {
	        let list = [];
	        for (let v of value) {
	            list.push(jsToMal(v));
	        }
	        return new types.MalVector(list);
	    }
	    if (typeof value === 'object') {
	        const entries = Object.entries(value).reduce((accum, v) => accum.concat(v), []);
	        let list = [];
	        for (let v of entries) {
	            list.push(jsToMal(v));
	        }
	        return new types.MalHashMap(list);
	    }
	    throw new Error(`JS Type not supported: ${str || obj}`);
	}
	exports.jsToMal = jsToMal;
	function tay2js(obj) {
	    if (!obj) {
	        console.debug(`Could not transform to JS`, obj);
	        return obj;
	    }
	    if (obj.type === 2 /* Number */)
	        return obj.v;
	    if (obj.type === 3 /* String */)
	        return obj.v;
	    if (obj.type === 5 /* Boolean */)
	        return obj.v;
	    if (obj.type === 6 /* Symbol */)
	        return obj.v;
	    if (obj.type === 7 /* Keyword */)
	        return obj.v;
	    if (obj.type === 4 /* Nil */)
	        return null;
	    if (obj.type === 10 /* Function */)
	        return obj.func;
	    if (obj.type === 1 /* List */)
	        return obj.list.map(tay2js);
	    if (obj.type === 8 /* Vector */)
	        return obj.list.map(tay2js);
	    if (obj.type === 9 /* HashMap */) {
	        const jsobj = {};
	        Object.keys(obj.stringMap).forEach(key => {
	            jsobj[key] = tay2js(obj.stringMap[key]);
	        });
	        return jsobj;
	    }
	    // console.debug(`Could not transform to JS: ${obj.type}`, obj);
	    return obj;
	}
	exports.tay2js = tay2js;
	});

	var core = createCommonjsModule(function (module, exports) {
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ns = void 0;




	exports.ns = (() => {
	    const ns = {
	        "="(a, b) {
	            return new types.MalBoolean(types.equals(a, b));
	        },
	        throw(v) {
	            throw v;
	        },
	        "nil?"(v) {
	            return new types.MalBoolean(v.type === 4 /* Nil */);
	        },
	        "true?"(v) {
	            return new types.MalBoolean(v.type === 5 /* Boolean */ && v.v);
	        },
	        "false?"(v) {
	            return new types.MalBoolean(v.type === 5 /* Boolean */ && !v.v);
	        },
	        "string?"(v) {
	            return new types.MalBoolean(v.type === 3 /* String */);
	        },
	        symbol(v) {
	            if (v.type !== 3 /* String */) {
	                throw new Error(`unexpected symbol: ${v.type}, expected: string`);
	            }
	            return types.MalSymbol.get(v.v);
	        },
	        "symbol?"(v) {
	            return new types.MalBoolean(v.type === 6 /* Symbol */);
	        },
	        keyword(v) {
	            if (v.type === 7 /* Keyword */) {
	                return v;
	            }
	            if (v.type !== 3 /* String */) {
	                throw new Error(`unexpected symbol: ${v.type}, expected: string`);
	            }
	            return types.MalKeyword.get(v.v);
	        },
	        "keyword?"(v) {
	            return new types.MalBoolean(v.type === 7 /* Keyword */);
	        },
	        "number?"(v) {
	            return new types.MalBoolean(v.type === 2 /* Number */);
	        },
	        "fn?"(v) {
	            return new types.MalBoolean(v.type === 10 /* Function */ && !v.isMacro);
	        },
	        "macro?"(v) {
	            return new types.MalBoolean(v.type === 10 /* Function */ && v.isMacro);
	        },
	        "pr-str"(...args) {
	            return new types.MalString(args.map(v => printer.prStr(v, true)).join(" "));
	        },
	        "str"(...args) {
	            return new types.MalString(args.map(v => printer.prStr(v, false)).join(""));
	        },
	        prn(...args) {
	            const str = args.map(v => printer.prStr(v, true)).join(" ");
	            console.log(str);
	            return types.MalNil.instance;
	        },
	        println(...args) {
	            const str = args.map(v => printer.prStr(v, false)).join(" ");
	            console.log(str);
	            return types.MalNil.instance;
	        },
	        "read-string"(v) {
	            if (v.type !== 3 /* String */) {
	                throw new Error(`unexpected symbol: ${v.type}, expected: string`);
	            }
	            return reader.readStr(v.v);
	        },
	        slurp(v) {
	            if (v.type !== 3 /* String */) {
	                throw new Error(`unexpected symbol: ${v.type}, expected: string`);
	            }
	            throw new Error(`Not available`);
	        },
	        "<"(a, b) {
	            if (a.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${a.type}, expected: number`);
	            }
	            if (b.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${b.type}, expected: number`);
	            }
	            return new types.MalBoolean(a.v < b.v);
	        },
	        "<="(a, b) {
	            if (a.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${a.type}, expected: number`);
	            }
	            if (b.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${b.type}, expected: number`);
	            }
	            return new types.MalBoolean(a.v <= b.v);
	        },
	        ">"(a, b) {
	            if (a.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${a.type}, expected: number`);
	            }
	            if (b.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${b.type}, expected: number`);
	            }
	            return new types.MalBoolean(a.v > b.v);
	        },
	        ">="(a, b) {
	            if (a.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${a.type}, expected: number`);
	            }
	            if (b.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${b.type}, expected: number`);
	            }
	            return new types.MalBoolean(a.v >= b.v);
	        },
	        "+"(a, b) {
	            if (a.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${a.type}, expected: number`);
	            }
	            if (b.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${b.type}, expected: number`);
	            }
	            return new types.MalNumber(a.v + b.v);
	        },
	        "-"(a, b) {
	            if (a.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${a.type}, expected: number`);
	            }
	            if (b.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${b.type}, expected: number`);
	            }
	            return new types.MalNumber(a.v - b.v);
	        },
	        "*"(a, b) {
	            if (a.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${a.type}, expected: number`);
	            }
	            if (b.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${b.type}, expected: number`);
	            }
	            return new types.MalNumber(a.v * b.v);
	        },
	        "/"(a, b) {
	            if (a.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${a.type}, expected: number`);
	            }
	            if (b.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${b.type}, expected: number`);
	            }
	            return new types.MalNumber(a.v / b.v);
	        },
	        "time-ms"() {
	            return new types.MalNumber(Date.now());
	        },
	        list(...args) {
	            return new types.MalList(args);
	        },
	        "list?"(v) {
	            return new types.MalBoolean(v.type === 1 /* List */);
	        },
	        vector(...args) {
	            return new types.MalVector(args);
	        },
	        "vector?"(v) {
	            return new types.MalBoolean(v.type === 8 /* Vector */);
	        },
	        "hash-map"(...args) {
	            return new types.MalHashMap(args);
	        },
	        "map?"(v) {
	            return new types.MalBoolean(v.type === 9 /* HashMap */);
	        },
	        assoc(v, ...args) {
	            if (v.type !== 9 /* HashMap */) {
	                throw new Error(`unexpected symbol: ${v.type}, expected: hash-map`);
	            }
	            return v.assoc(args);
	        },
	        dissoc(v, ...args) {
	            if (v.type !== 9 /* HashMap */) {
	                throw new Error(`unexpected symbol: ${v.type}, expected: hash-map`);
	            }
	            return v.dissoc(args);
	        },
	        get(v, key) {
	            if (v.type === 4 /* Nil */) {
	                return types.MalNil.instance;
	            }
	            if (v.type !== 9 /* HashMap */) {
	                throw new Error(`unexpected symbol: ${v.type}, expected: hash-map`);
	            }
	            if (key.type !== 3 /* String */ && key.type !== 7 /* Keyword */) {
	                throw new Error(`unexpected symbol: ${key.type}, expected: string or keyword`);
	            }
	            return v.get(key) || types.MalNil.instance;
	        },
	        "contains?"(v, key) {
	            if (v.type === 4 /* Nil */) {
	                return types.MalNil.instance;
	            }
	            if (v.type !== 9 /* HashMap */) {
	                throw new Error(`unexpected symbol: ${v.type}, expected: hash-map`);
	            }
	            if (key.type !== 3 /* String */ && key.type !== 7 /* Keyword */) {
	                throw new Error(`unexpected symbol: ${key.type}, expected: string or keyword`);
	            }
	            return new types.MalBoolean(v.has(key));
	        },
	        keys(v) {
	            if (v.type !== 9 /* HashMap */) {
	                throw new Error(`unexpected symbol: ${v.type}, expected: hash-map`);
	            }
	            return new types.MalList([...v.keys()]);
	        },
	        vals(v) {
	            if (v.type !== 9 /* HashMap */) {
	                throw new Error(`unexpected symbol: ${v.type}, expected: hash-map`);
	            }
	            return new types.MalList([...v.vals()]);
	        },
	        "sequential?"(v) {
	            return new types.MalBoolean(types.isSeq(v));
	        },
	        cons(a, b) {
	            if (!types.isSeq(b)) {
	                throw new Error(`unexpected symbol: ${b.type}, expected: list or vector`);
	            }
	            return new types.MalList([a].concat(b.list));
	        },
	        concat(...args) {
	            const list = args
	                .map(arg => {
	                if (!types.isSeq(arg)) {
	                    throw new Error(`unexpected symbol: ${arg.type}, expected: list or vector`);
	                }
	                return arg;
	            })
	                .reduce((p, c) => p.concat(c.list), []);
	            return new types.MalList(list);
	        },
	        vec(a) {
	            switch (a.type) {
	                case 1 /* List */:
	                    return new types.MalVector(a.list);
	                case 8 /* Vector */:
	                    return a;
	            }
	            throw new Error(`unexpected symbol: ${a.type}, expected: list or vector`);
	        },
	        nth(list, idx) {
	            if (!types.isSeq(list)) {
	                throw new Error(`unexpected symbol: ${list.type}, expected: list or vector`);
	            }
	            if (idx.type !== 2 /* Number */) {
	                throw new Error(`unexpected symbol: ${idx.type}, expected: number`);
	            }
	            const v = list.list[idx.v];
	            if (!v) {
	                throw new Error("nth: index out of range");
	            }
	            return v;
	        },
	        first(v) {
	            if (v.type === 4 /* Nil */) {
	                return types.MalNil.instance;
	            }
	            if (!types.isSeq(v)) {
	                throw new Error(`unexpected symbol: ${v.type}, expected: list or vector`);
	            }
	            return v.list[0] || types.MalNil.instance;
	        },
	        rest(v) {
	            if (v.type === 4 /* Nil */) {
	                return new types.MalList([]);
	            }
	            if (!types.isSeq(v)) {
	                throw new Error(`unexpected symbol: ${v.type}, expected: list or vector`);
	            }
	            return new types.MalList(v.list.slice(1));
	        },
	        "empty?"(v) {
	            if (!types.isSeq(v)) {
	                return new types.MalBoolean(false);
	            }
	            return new types.MalBoolean(v.list.length === 0);
	        },
	        count(v) {
	            if (types.isSeq(v)) {
	                return new types.MalNumber(v.list.length);
	            }
	            if (v.type === 4 /* Nil */) {
	                return new types.MalNumber(0);
	            }
	            throw new Error(`unexpected symbol: ${v.type}`);
	        },
	        apply(f, ...list) {
	            if (f.type !== 10 /* Function */) {
	                throw new Error(`unexpected symbol: ${f.type}, expected: function`);
	            }
	            const tail = list[list.length - 1];
	            if (!types.isSeq(tail)) {
	                throw new Error(`unexpected symbol: ${tail.type}, expected: list or vector`);
	            }
	            const args = list.slice(0, -1).concat(tail.list);
	            return f.func(...args);
	        },
	        map(f, list) {
	            return __awaiter(this, void 0, void 0, function* () {
	                if (f.type !== 10 /* Function */) {
	                    throw new Error(`unexpected symbol: ${f.type}, expected: function`);
	                }
	                if (!types.isSeq(list)) {
	                    throw new Error(`unexpected symbol: ${list.type}, expected: list or vector`);
	                }
	                const l = [];
	                for (const v of list.list) {
	                    l.push(yield f.func(v));
	                }
	                return new types.MalList(l);
	            });
	        },
	        conj(list, ...args) {
	            switch (list.type) {
	                case 1 /* List */:
	                    const newList = new types.MalList(list.list);
	                    args.forEach(arg => newList.list.unshift(arg));
	                    return newList;
	                case 8 /* Vector */:
	                    return new types.MalVector([...list.list, ...args]);
	            }
	            throw new Error(`unexpected symbol: ${list.type}, expected: list or vector`);
	        },
	        seq(v) {
	            if (v.type === 1 /* List */) {
	                if (v.list.length === 0) {
	                    return types.MalNil.instance;
	                }
	                return v;
	            }
	            if (v.type === 8 /* Vector */) {
	                if (v.list.length === 0) {
	                    return types.MalNil.instance;
	                }
	                return new types.MalList(v.list);
	            }
	            if (v.type === 3 /* String */) {
	                if (v.v.length === 0) {
	                    return types.MalNil.instance;
	                }
	                return new types.MalList(v.v.split("").map(s => new types.MalString(s)));
	            }
	            if (v.type === 4 /* Nil */) {
	                return types.MalNil.instance;
	            }
	            throw new Error(`unexpected symbol: ${v.type}, expected: list or vector or string`);
	        },
	        meta(v) {
	            return v.meta || types.MalNil.instance;
	        },
	        "with-meta"(v, m) {
	            return v.withMeta(m);
	        },
	        atom(v) {
	            return new types.MalAtom(v);
	        },
	        "atom?"(v) {
	            return new types.MalBoolean(v.type === 11 /* Atom */);
	        },
	        deref(v) {
	            if (v.type !== 11 /* Atom */) {
	                throw new Error(`unexpected symbol: ${v.type}, expected: atom`);
	            }
	            return v.v;
	        },
	        "reset!"(atom, v) {
	            if (atom.type !== 11 /* Atom */) {
	                throw new Error(`unexpected symbol: ${atom.type}, expected: atom`);
	            }
	            atom.v = v;
	            return v;
	        },
	        "swap!"(atom, f, ...args) {
	            return __awaiter(this, void 0, void 0, function* () {
	                if (atom.type !== 11 /* Atom */) {
	                    throw new Error(`unexpected symbol: ${atom.type}, expected: atom`);
	                }
	                if (f.type !== 10 /* Function */) {
	                    throw new Error(`unexpected symbol: ${f.type}, expected: function`);
	                }
	                atom.v = yield f.func(...[atom.v].concat(args));
	                return atom.v;
	            });
	        },
	        "js-eval"(str) {
	            if (str.type === 3 /* String */) {
	                return interop.jsToMal(eval(str.v));
	            }
	            return str;
	        },
	        '.'(object_method_str) {
	            return __awaiter(this, arguments, void 0, function* () {
	                const args = Array.prototype.slice.call(arguments, 1);
	                if (object_method_str.type !== 3 /* String */)
	                    throw new Error('dot notation expects Symol');
	                const r = interop.resolveJs(object_method_str.v), obj = r[0], f = r[1];
	                var res = yield f.apply(obj, args);
	                return interop.jsToMal(res);
	            });
	        }
	    };
	    const map = new Map();
	    Object.keys(ns).forEach(key => map.set(types.MalSymbol.get(key), types.MalFunction.fromBootstrap(ns[key])));
	    return map;
	})();
	});

	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};



	const core$1 = __importStar(core);


	// READ
	function read(str) {
	    return reader.readStr(str);
	}
	function starts_with(lst, sym) {
	    if (lst.length == 2) {
	        let a0 = lst[0];
	        switch (a0.type) {
	            case 6 /* Symbol */:
	                return a0.v === sym;
	        }
	    }
	    return false;
	}
	function qq_loop(elt, acc) {
	    if (elt.type == 1 /* List */ && starts_with(elt.list, "splice-unquote")) {
	        return new types.MalList([types.MalSymbol.get("concat"), elt.list[1], acc]);
	    }
	    else {
	        return new types.MalList([types.MalSymbol.get("cons"), quasiquote(elt), acc]);
	    }
	}
	function qq_foldr(xs) {
	    let acc = new types.MalList([]);
	    for (let i = xs.length - 1; 0 <= i; i -= 1) {
	        acc = qq_loop(xs[i], acc);
	    }
	    return acc;
	}
	function quasiquote(ast) {
	    switch (ast.type) {
	        case 6 /* Symbol */:
	            return new types.MalList([types.MalSymbol.get("quote"), ast]);
	        case 9 /* HashMap */:
	            return new types.MalList([types.MalSymbol.get("quote"), ast]);
	        case 1 /* List */:
	            if (starts_with(ast.list, "unquote")) {
	                return ast.list[1];
	            }
	            else {
	                return qq_foldr(ast.list);
	            }
	        case 8 /* Vector */:
	            return new types.MalList([types.MalSymbol.get("vec"), qq_foldr(ast.list)]);
	        default:
	            return ast;
	    }
	}
	function isMacro(ast, env) {
	    if (!types.isSeq(ast)) {
	        return false;
	    }
	    const s = ast.list[0];
	    if (s.type !== 6 /* Symbol */) {
	        return false;
	    }
	    const foundEnv = env.find(s);
	    if (!foundEnv) {
	        return false;
	    }
	    const f = foundEnv.get(s);
	    if (f.type !== 10 /* Function */) {
	        return false;
	    }
	    return f.isMacro;
	}
	function macroexpand(ast, env) {
	    return __awaiter(this, void 0, void 0, function* () {
	        while (isMacro(ast, env)) {
	            if (!types.isSeq(ast)) {
	                throw new Error(`unexpected token type: ${ast.type}, expected: list or vector`);
	            }
	            const s = ast.list[0];
	            if (s.type !== 6 /* Symbol */) {
	                throw new Error(`unexpected token type: ${s.type}, expected: symbol`);
	            }
	            const f = env.get(s);
	            if (f.type !== 10 /* Function */) {
	                throw new Error(`unexpected token type: ${f.type}, expected: function`);
	            }
	            ast = yield f.func(...ast.list.slice(1));
	        }
	        return ast;
	    });
	}
	function evalAST(ast, env) {
	    return __awaiter(this, void 0, void 0, function* () {
	        switch (ast.type) {
	            case 6 /* Symbol */:
	                const f = env.get(ast);
	                if (!f) {
	                    throw new Error(`unknown symbol: ${ast.v}`);
	                }
	                return f;
	            case 1 /* List */:
	                const l = [];
	                for (const astitem of ast.list) {
	                    l.push(yield evalMal(astitem, env));
	                }
	                return new types.MalList(l);
	            case 8 /* Vector */:
	                const v = [];
	                for (const astitem of ast.list) {
	                    v.push(yield evalMal(astitem, env));
	                }
	                return new types.MalVector(v);
	            case 9 /* HashMap */:
	                const list = [];
	                for (const [key, value] of ast.entries()) {
	                    list.push(key);
	                    list.push(yield evalMal(value, env));
	                }
	                return new types.MalHashMap(list);
	            default:
	                return ast;
	        }
	    });
	}
	// EVAL
	function evalMal(ast, env$1) {
	    return __awaiter(this, void 0, void 0, function* () {
	        loop: while (true) {
	            if (ast.type !== 1 /* List */) {
	                return evalAST(ast, env$1);
	            }
	            if (ast.list.length === 0) {
	                return ast;
	            }
	            ast = yield macroexpand(ast, env$1);
	            if (!types.isSeq(ast)) {
	                return evalAST(ast, env$1);
	            }
	            if (ast.list.length === 0) {
	                return ast;
	            }
	            const first = ast.list[0];
	            switch (first.type) {
	                case 6 /* Symbol */:
	                    switch (first.v) {
	                        case "def!": {
	                            const [, key, value] = ast.list;
	                            if (key.type !== 6 /* Symbol */) {
	                                throw new Error(`unexpected token type: ${key.type}, expected: symbol`);
	                            }
	                            if (!value) {
	                                throw new Error(`unexpected syntax`);
	                            }
	                            return env$1.set(key, yield evalMal(value, env$1));
	                        }
	                        case "let*": {
	                            env$1 = new env.Env(env$1);
	                            const pairs = ast.list[1];
	                            if (!types.isSeq(pairs)) {
	                                throw new Error(`unexpected token type: ${pairs.type}, expected: list or vector`);
	                            }
	                            for (let i = 0; i < pairs.list.length; i += 2) {
	                                const key = pairs.list[i];
	                                const value = pairs.list[i + 1];
	                                if (key.type !== 6 /* Symbol */) {
	                                    throw new Error(`unexpected token type: ${key.type}, expected: symbol`);
	                                }
	                                if (!key || !value) {
	                                    throw new Error(`unexpected syntax`);
	                                }
	                                env$1.set(key, yield evalMal(value, env$1));
	                            }
	                            ast = ast.list[2];
	                            continue loop;
	                        }
	                        case "quote": {
	                            return ast.list[1];
	                        }
	                        case "mquote": {
	                            const l = ast.list[1];
	                            if (l.type !== 1 /* List */)
	                                return l;
	                            const value = l.list.map((item) => {
	                                // @ts-ignore
	                                return printer.prStr(item);
	                            }).join(' ');
	                            const multiStr = new types.MalString('(' + value + ')');
	                            return multiStr;
	                        }
	                        case "mquote-noparens": {
	                            const l = ast.list[1];
	                            if (l.type !== 1 /* List */)
	                                return l;
	                            const value = l.list.map((item) => {
	                                // @ts-ignore
	                                return printer.prStr(item);
	                            }).join(' ');
	                            const multiStr = new types.MalString(value);
	                            return multiStr;
	                        }
	                        case "quasiquoteexpand": {
	                            return quasiquote(ast.list[1]);
	                        }
	                        case "quasiquote": {
	                            ast = quasiquote(ast.list[1]);
	                            continue loop;
	                        }
	                        case "defmacro!": {
	                            const [, key, value] = ast.list;
	                            if (key.type !== 6 /* Symbol */) {
	                                throw new Error(`unexpected token type: ${key.type}, expected: symbol`);
	                            }
	                            if (!value) {
	                                throw new Error(`unexpected syntax`);
	                            }
	                            const f = yield evalMal(value, env$1);
	                            if (f.type !== 10 /* Function */) {
	                                throw new Error(`unexpected token type: ${f.type}, expected: function`);
	                            }
	                            return env$1.set(key, f.toMacro());
	                        }
	                        case "macroexpand": {
	                            return macroexpand(ast.list[1], env$1);
	                        }
	                        case "try*": {
	                            try {
	                                return evalMal(ast.list[1], env$1);
	                            }
	                            catch (e) {
	                                if (ast.list.length < 3) {
	                                    throw e;
	                                }
	                                const catchBody = ast.list[2];
	                                if (!types.isSeq(catchBody)) {
	                                    throw new Error(`unexpected return type: ${catchBody.type}, expected: list or vector`);
	                                }
	                                const catchSymbol = catchBody.list[0];
	                                if (catchSymbol.type === 6 /* Symbol */ && catchSymbol.v === "catch*") {
	                                    const errorSymbol = catchBody.list[1];
	                                    if (errorSymbol.type !== 6 /* Symbol */) {
	                                        throw new Error(`unexpected return type: ${errorSymbol.type}, expected: symbol`);
	                                    }
	                                    if (!types.isAST(e)) {
	                                        e = new types.MalString(e.message);
	                                    }
	                                    return evalMal(catchBody.list[2], new env.Env(env$1, [errorSymbol], [e]));
	                                }
	                                throw e;
	                            }
	                        }
	                        case "do": {
	                            const list = ast.list.slice(1, -1);
	                            yield evalAST(new types.MalList(list), env$1);
	                            ast = ast.list[ast.list.length - 1];
	                            continue loop;
	                        }
	                        case "if": {
	                            const [, cond, thenExpr, elseExrp] = ast.list;
	                            const ret = yield evalMal(cond, env$1);
	                            let b = true;
	                            if (ret.type === 5 /* Boolean */ && !ret.v) {
	                                b = false;
	                            }
	                            else if (ret.type === 4 /* Nil */) {
	                                b = false;
	                            }
	                            if (b) {
	                                ast = thenExpr;
	                            }
	                            else if (elseExrp) {
	                                ast = elseExrp;
	                            }
	                            else {
	                                ast = types.MalNil.instance;
	                            }
	                            continue loop;
	                        }
	                        case "and": {
	                            const [, ...args] = ast.list;
	                            for (let arg of args) {
	                                const v = yield evalMal(arg, env$1);
	                                if (v.type !== 5 /* Boolean */ || !v.v)
	                                    return new types.MalBoolean(false);
	                            }
	                            return new types.MalBoolean(true);
	                        }
	                        case "or": {
	                            const [, ...args] = ast.list;
	                            for (let arg of args) {
	                                const v = yield evalMal(arg, env$1);
	                                if (v.type === 5 /* Boolean */ && v.v)
	                                    return new types.MalBoolean(true);
	                            }
	                            return new types.MalBoolean(false);
	                        }
	                        case "fn*": {
	                            const [, params, bodyAst] = ast.list;
	                            if (!types.isSeq(params)) {
	                                throw new Error(`unexpected return type: ${params.type}, expected: list or vector`);
	                            }
	                            const symbols = params.list.map(param => {
	                                if (param.type !== 6 /* Symbol */) {
	                                    throw new Error(`unexpected return type: ${param.type}, expected: symbol`);
	                                }
	                                return param;
	                            });
	                            return types.MalFunction.fromLisp(evalMal, env$1, symbols, bodyAst);
	                        }
	                    }
	            }
	            const result = yield evalAST(ast, env$1);
	            if (!types.isSeq(result)) {
	                throw new Error(`unexpected return type: ${result.type}, expected: list or vector`);
	            }
	            const [f, ...args] = result.list;
	            if (f.type !== 10 /* Function */) {
	                throw new Error(`unexpected token: ${f.type}, expected: function`);
	            }
	            if (f.ast) {
	                ast = f.ast;
	                env$1 = f.newEnv(args);
	                continue loop;
	            }
	            return f.func(...args);
	        }
	    });
	}
	// PRINT
	function print(exp) {
	    return printer.prStr(exp);
	}
	const replEnv = new env.Env();
	function rep(str) {
	    return __awaiter(this, void 0, void 0, function* () {
	        return print(yield evalMal(read(str), replEnv));
	    });
	}
	// core.EXT: defined using Racket
	core$1.ns.forEach((value, key) => {
	    replEnv.set(key, value);
	});
	replEnv.set(types.MalSymbol.get("eval"), types.MalFunction.fromBootstrap(ast => {
	    if (!ast) {
	        throw new Error(`undefined argument`);
	    }
	    return evalMal(ast, replEnv);
	}));
	replEnv.set(types.MalSymbol.get("*ARGV*"), new types.MalList([]));
	// core.mal: defined using the language itself
	rep(`(def! *host-language* "TypeScript")`);
	rep("(def! not (fn* (a) (if a false true)))");
	rep(`(def! load-file (fn* (f) (eval (read-string (str "(do " (slurp f) "\nnil)")))))`);
	rep(`(defmacro! cond (fn* (& xs) (if (> (count xs) 0) (list 'if (first xs) (if (> (count xs) 1) (nth xs 1) (throw "odd number of forms to cond")) (cons 'cond (rest (rest xs)))))))`);
	let mal = {
	    eval: evalMal,
	    print,
	    read,
	    replEnv,
	    rep,
	};
	var _default = mal;

	var mal_1 = /*#__PURE__*/Object.defineProperty({
		default: _default
	}, '__esModule', {value: true});

	var __createBinding$1 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault$1 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar$1 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1(result, mod, k);
	    __setModuleDefault$1(result, mod);
	    return result;
	};
	var __awaiter$1 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};

	const mal_1$1 = __importDefault(mal_1);
	const malTypes = __importStar$1(types);

	const interop$1 = __importStar$1(interop);

	function envWrap(_env) {
	    const wrapper = {
	        _env,
	        data: {},
	        set: (key, value) => {
	            const _key = types.MalSymbol.get(key);
	            const _value = interop$1.jsToMal(value);
	            return _env.set(_key, _value);
	        },
	        setraw: (key, value) => {
	            const _key = types.MalSymbol.get(key);
	            return _env.set(_key, value);
	        },
	        get: (key) => {
	            const _key = types.MalSymbol.get(key);
	            const value = _env.get(_key);
	            return value;
	        },
	        getAll: () => _env.data,
	        clear: () => {
	            _env.data = new Map();
	        },
	        debug(status) {
	            wrapper._env.debug = status;
	        },
	        flushDebug: () => {
	            wrapper._env.flushDebug();
	        },
	        getDebug: () => {
	            return wrapper._env.operations;
	        }
	    };
	    return wrapper;
	}
	function envNew(oldenv, _constructor) {
	    const Constructor = _constructor || env.Env;
	    const _env = new Constructor(oldenv || mal_1$1.default.replEnv);
	    return envWrap(_env);
	}
	const taylor = {
	    _: mal_1$1.default,
	    types: malTypes,
	    interop: interop$1,
	    Env: env.Env,
	    eval: (expr, _env) => __awaiter$1(void 0, void 0, void 0, function* () {
	        if (!_env)
	            _env = mal_1$1.default.replEnv;
	        else
	            _env = _env._env;
	        const result = yield mal_1$1.default.eval(mal_1$1.default.read(expr), _env);
	        return interop$1.tay2js(result);
	    }),
	    envNew,
	    global: envWrap(mal_1$1.default.replEnv),
	    extendfn: (name, func, _env) => {
	        if (!_env)
	            _env = taylor.global;
	        const funcwrap = (...args) => {
	            const jsargs = args.map((v) => taylor.interop.tay2js(v));
	            return func(...jsargs);
	        };
	        const _func = malTypes.MalFunction.fromBootstrap(funcwrap);
	        _env.setraw(name, _func);
	    }
	};
	var _default$1 = taylor;

	return _default$1;

})));
